/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState } from 'react';

import { Colors, Spacing } from 'src/common/ui/base';
import { CircleButton } from 'src/common/ui/components';
import { NAV_HEIGHT } from 'src/components/app/Nav/Nav';
import { NavIconsFeedback } from 'src/components/app/Nav/Nav.Icons.Feedback';
import { NavIconsMyDayToday } from 'src/components/app/Nav/Nav.Icons.MyDayToday';
import EventCreateIcon from 'src/components/general/eventCreateIcon';
import { DoseSpotNotificationsIcon } from 'src/prescribing/doseSpot/components/DoseSpotNotificationsIcon';
import type { Provider } from 'src/shared/stores/resource';
import useRootStore from 'src/stores/useRootStore';

export const NavIcons = () => {
  const { auth, flash, routerStore } = useRootStore();

  const [anchorEl, setAnchorEl] = useState(null);

  const user = auth.user as Provider;

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    auth.logout();
    handleCloseMenu();
    routerStore.goTo('login');
    flash('You are now logged out.');
  };

  const handleProfile = () => {
    routerStore.goTo('editProvider', {
      params: {
        id: user.id,
      },
    });
    handleCloseMenu();
  };

  return (
    <nav
      data-testid="nav-icons"
      css={css`
        margin-left: auto;
        flex-wrap: nowrap;
        display: flex;
        height: ${NAV_HEIGHT}px;
        align-items: center;
        justify-content: center;
      `}
    >
      <div
        css={css`
          display: none;
          @media (min-width: 768px) {
            display: inline-flex;
          }
        `}
      >
        <NavIconsFeedback />

        <NavIconsMyDayToday />

        <DoseSpotNotificationsIcon />

        <EventCreateIcon />
      </div>

      <Tooltip title="Your profile">
        <span>
          <CircleButton
            color="transparent-inverted"
            data-testid="nav-icons-account"
            icon="accountCircle"
            onClick={handleMenu}
          />
        </span>
      </Tooltip>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem css={menuItemStyles} onClick={handleProfile} data-testid="profile-menu-item">
          Profile
        </MenuItem>
        <MenuItem css={menuItemStyles} onClick={handleLogout}>
          Log out
        </MenuItem>
      </Menu>
    </nav>
  );
};

const menuItemStyles = css`
  padding-top: ${Spacing.Unit2}px;
  padding-bottom: ${Spacing.Unit2}px;
  display: block;

  &:hover {
    background-color: ${Colors.CoolGray1};
  }
`;
